import { render, staticRenderFns } from "./DailyBurnInDataStatistic.vue?vue&type=template&id=9b045d80"
import script from "./DailyBurnInDataStatistic.vue?vue&type=script&lang=js"
export * from "./DailyBurnInDataStatistic.vue?vue&type=script&lang=js"
import style0 from "./DailyBurnInDataStatistic.vue?vue&type=style&index=0&id=9b045d80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports